import { render, staticRenderFns } from "./PagesSelector.vue?vue&type=template&id=4ea05159"
import script from "./PagesSelector.vue?vue&type=script&lang=js"
export * from "./PagesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports